import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useAppContext } from "./context/useContext";
import { ToastContainer } from "react-toastify";
// page
import {
  Home,
  Login,
  Register,
  ForgetPassword,
  Error,
  ProtectedLayout,
  ShareLayout,
} from "./page";
// layout
import { Dashboard, Messenger, Admin } from "./page/Layout";
import { Profile, UpdateProfile } from "./page/user";
import { Information } from "./page/Post";
// modal qrCode
import { ModalQrCode } from "./components";
// trello
import Boards from "./components/trello/Pages/BoardsPage/Boards";
import Board from "./components/trello/Pages/BoardPage/Board";
import Index from "./components/trello/Pages/IndexPage/Index";
import AlertSnackBar from "./components/trello/AlertSnackBar";
import { loadUser } from "./Services/userService";
import Store from "./Redux/Store";

const App = () => {
  const { dark, openModal, isQrCode, autoFetch } = useAppContext();
  useEffect(() => {
    loadUser(Store.dispatch, autoFetch);
  }, [autoFetch]);

  return (
    <div className={`${dark ? "dark" : ""} relative `}>
      {/* Notification */}
      <ToastContainer
        position="top-right"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        theme={dark ? "dark" : "light"}
      />
      {/*QR code*/}
      {openModal && isQrCode && <ModalQrCode />}
      {/* Router */}
      <BrowserRouter>
        {/* Alert Snackbar for Redux alerts - must be inside BrowserRouter for useNavigate */}
        <AlertSnackBar />
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedLayout>
                <ShareLayout />
              </ProtectedLayout>
            }
          >
            <Route
              // @ts-ignore
              index
              path="/"
              element={<Dashboard />}
            />
            <Route path="/messenger" element={<Messenger />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/profile/*" element={<Profile />} />
            <Route path="/update-profile" element={<UpdateProfile />} />
            <Route path="/post/information/:id" element={<Information />} />
            <Route exact path="/task/boards" element={<Boards />} />
            <Route exact path="/task/board/:id" element={<Board />} />
            <Route exact path="/task" element={<Index />} />
          </Route>

          <Route path="/home" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/forget-password" element={<ForgetPassword />} />

          <Route path="*" element={<Error />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
};

export default App;
